/**
 * The one place that turns an unknown thrown value into a user-facing
 * error: ApiError (typed backend failure) vs network TypeError vs anything
 * else, each with the right i18n message and an optional retry button.
 */
import { Alert, AlertTitle, Button, type SxProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { describeError } from "../../lib/errors";

export function ErrorAlert({
  error,
  onRetry,
  sx,
}: {
  error: unknown;
  onRetry?: () => void;
  sx?: SxProps;
}) {
  const { t } = useTranslation();
  const { kind, message } = describeError(error);

  const title =
    kind === "network" ? t("errors.network") : t("errors.loadFailed");

  return (
    <Alert
      severity="error"
      sx={sx}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            {t("common.retry")}
          </Button>
        ) : undefined
      }
    >
      <AlertTitle>{title}</AlertTitle>
      {message ?? (kind === "network" ? t("errors.networkHint") : t("errors.unknown"))}
    </Alert>
  );
}
